import "../../../field.js";
import "#vendor/jquery_plugins/jquery.mask.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.PatientStep ??= {};

AppointmentBooking.Wizard.Views.PatientStep.DateOfBirthField = class DateOfBirthField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.decorateField = this.decorateField.bind(this);
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.decorateField();

    return this;
  }

  // PRIVATE

  decorateField() {
    return jQuery.when().then(() => this.$(":input[name=date_of_birth]").mask("09/09/0000"));
  }
};
AppointmentBooking.Wizard.Views.PatientStep.DateOfBirthField.prototype.template = "step/patient/fields/date_of_birth";
AppointmentBooking.Wizard.Views.PatientStep.DateOfBirthField.prototype.className =
  "appointment-booking-wizard-patient-step-date-field";
